export const modelQuoteRequestPath = '/model-quote-request';

export const getModelQuoteRequestUrl = (modelId: string, quantity: number, url: string) => {
  const nextURL = new URLSearchParams();
  nextURL.set('modelId', modelId);
  nextURL.set('quantity', quantity.toString());
  nextURL.set('url', url);

  return modelQuoteRequestPath + '?' + nextURL.toString();
};